<!-- BEGIN: Footer-->
<footer class="footer footer-static footer-light yhyl-noborder">
  <p class="clearfix blue-grey lighten-2 text-sm-center mb-0 px-2">
    <span class=" d-block d-md-inline-block yhyl-text"> &copy; Copyright <strong><span>Your 100 Year
          Life</span></strong>. All Rights Reserved</span>
  </p>
</footer>
<!-- END: Footer-->